let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9eMDo")).then(() => parcelRequire('kxY57'));